import { defineStore } from 'pinia';
import dayjs from 'dayjs';
import axios from 'axios';

type GoogleUserInfo = {
	name: string;
	given_name: string;
	family_name: string;
	email: string;
	picture: string;
	exp: number;
};

export default defineStore('user', {
	state: () => ({
		name: '',
		givenName: '',
		familyName: '',
		email: '',
		picture: '',
		tokenExpirationDate: 0,
		isUserLoggedIn: false,
	}),
	getters: {
		tokenExpirationDateToNormal: (state) =>
			dayjs(state.tokenExpirationDate * 1000).format('h:mm:ss'),
	},
	actions: {
		storeUser(userInfo: GoogleUserInfo, userJWT: string) {
			// Save to state
			this.name = userInfo?.name;
			this.givenName = userInfo.given_name;
			this.familyName = userInfo.family_name;
			this.email = userInfo.email;
			this.picture = userInfo.picture;
			this.tokenExpirationDate = userInfo.exp;
			this.isUserLoggedIn = true;

			axios.defaults.headers.common = {
				'Authorization': `${userJWT}`,
				'x-user': userInfo.email,
			};
		},
		logoutUser() {
			this.isUserLoggedIn = false;
			localStorage.removeItem('JWT');
			localStorage.removeItem('userInfo');
			localStorage.setItem('isUserLoggedIn', 'false');
		},
	},
});
